/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const SYNTAX_HIGHLIGHT_TYPESCRIPT = 'typescript';
export const SYNTAX_HIGHLIGHT_JAVASCRIPT = 'javascript';
export const SYNTAX_HIGHLIGHT_HTML = 'markup';
export const SYNTAX_HIGHLIGHT_SCSS = 'scss';
export const SYNTAX_HIGHLIGHT_CSS = 'css';
export const SYNTAX_HIGHLIGHT_TS_REACT = 'tsx';
export const SYNTAX_HIGHLIGHT_REACT = 'jsx';
